import {useEffect, useState} from "react";
import styles from './style.module.scss';
import Step1 from "./components/steps/step1";
import Step2 from "./components/steps/step2";
import Step3 from "./components/steps/step3";
import Step4 from "./components/steps/step4";
import Step5 from "./components/steps/step5";
import Step6 from "./components/steps/step6";
import useStore from "./store/store";
import {host} from "./const/const";
import Summary from "./components/summary/summary";
import Step7 from "./components/steps/step7";
import {normalizeWorkTime} from "./utils/work-time";
import {parseAppVersion} from "./utils/app-version";

if (process.env.NODE_ENV === 'development') {
    import('./global.css').then((module) => {
        // Используйте module
    });
}


function getId(metaName) {
    let elem = document.getElementById('order-form')
    if (elem) {
        return elem.dataset.id;
    }
    return null;
}

function getLang() {
    let elem = document.getElementById('order-form')
    if (elem) {
        return elem?.dataset?.lang || 'ru';
    }
    return 'ru';
}

function addHoursToDate(date, h) {
    const result = new Date(date);
    result.setHours(result.getHours() + h);
    return result;
}

function App() {
    const [loading, setLoading] = useState(true);
    const [calcData, setCalcData] = useState(null)
    const setCurrentDate = useStore((state) => state.setCurrentDate)
    const setCarId = useStore((state) => state.setCarId)
    const setAvailableMode = useStore((state) => state.setAvailableMode)
    const setSummaryHead = useStore((state) => state.setSummaryHead)
    const setUser = useStore((state) => state.setUser)
    const setUserName = useStore((state) => state.setUserName)
    const setUserTel = useStore((state) => state.setUserTel)
    const setPromoHtml = useStore((state) => state.setPromoHtml)
    const setSortSale = useStore((state) => state.setSortSale)
    const setIskKz = useStore((state) => state.setIskKz)
    const setCountryCode = useStore((state) => state.setCountryCode)
    const setLang = useStore((state) => state.setLang)
    const setShortVersion = useStore((state) => state.setShortVersion)
    const setDevMode = useStore((state) => state.setDevMode)
    const setSurcharge = useStore((state) => state.setSurcharge)
    const setWorkTime = useStore((state) => state.setWorkTime)
    const setServices = useStore((state) => state.setServices)
    const setVer = useStore((state) => state.setVer)
    const setRatesHide = useStore((state) => state.setRatesHide)
    const lang = useStore((state) => state.lang)
    const shortVersion = useStore((state) => state.shortVersion)
    const ver = useStore((state) => state.ver)
    const getApiData = async (carId) => {
        try {
            const response = await fetch(
                `${host}?action=get_car_calc_data&id=${carId}`
            ).then((response) => response.json());
            setCalcData(response);
            setVer(parseAppVersion(response?.ver));
            setLoading(false);
            if (response?.promo_html) {
                setPromoHtml(response.promo_html)
            }
            if (response?.sort_sale) {
                setSortSale(response.sort_sale)
            }
            if (response?.available) {
                setAvailableMode(response.available)
            }
            if (response?.isKz && parseInt(response?.isKz) === 1) {
                setIskKz(true)
            }
            if (response?.countryCode && response.countryCode.length === 2) {
                setCountryCode(response.countryCode.toUpperCase())
            }
            if (response?.user) {
                setUser(response.user)
                if (!!response?.user?.fio) {
                    setUserName(response.user.fio)
                }
                if (response?.user?.tel) {
                    setUserTel(response.user.tel)
                }
            }
            if (response?.summaryHead) {
                setSummaryHead(response.summaryHead)
            }
            if (!!response?.shortVersion) {
                setShortVersion(true);
            }
            if (!!response?.devMode) {
                setDevMode(true);
            }
            if (!!response?.surcharge){
                setSurcharge(parseInt(response.surcharge));
            } else {
                //setSurcharge(10);
            }
            if (response?.work_time) {
                setWorkTime(normalizeWorkTime(response.work_time));
            }
            if (response?.services) {
                setServices(response.services);
            }
        } catch (error) {
            console.error(error.message);
        }
    };
    useEffect(() => {
        const carId = getId();
        const lang = getLang();
        if (!!lang) {
            setLang(lang);
        }
        if (carId > 0) {
            setCarId(carId);
            getApiData(carId);
        }
        setCurrentDate(addHoursToDate(new Date(), 3))
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // v2+: без шага выбора тарифа, номера остальных шагов сдвигаются через ratesHide
    useEffect(() => {
        setRatesHide(ver >= 2);
    }, [ver, setRatesHide]);

    if (loading) {
        return (<div>{lang === 'en' ? 'Loading' : 'Загрузка'}</div>)
    }
    return (
        <div className={styles.newOrder}>
            <div className={styles.newOrder__content}>
                {
                    shortVersion ? (<>
                        <Step1
                            number={1}
                            minRentDays={calcData?.minRentDays || 1}
                            crmCarId={calcData?.car?.carid || null}
                        />
                        <Step2 number={2}
                               car={calcData?.car || null}
                               rates={calcData?.rates.slice(0,2) || []}
                               promoFinishDate={calcData?.price_data?.promo?.finish_date || null}
                               promoPriceGrid={calcData?.price_data?.promo?.grid || null}
                               priceGrid={calcData?.price_data?.grid || null}
                               links={calcData?.links || null}
                        />
                    </>) : (<>
                        <Step1
                            number={1}
                            minRentDays={calcData?.minRentDays || 1}
                            crmCarId={calcData?.car?.carid || null}
                        />
                        <Step2 number={2}
                               car={calcData?.car || null}
                               rates={calcData?.rates || []}
                               promoFinishDate={calcData?.price_data?.promo?.finish_date || null}
                               promoPriceGrid={calcData?.price_data?.promo?.grid || null}
                               priceGrid={calcData?.price_data?.grid || null}
                               links={calcData?.links || null}
                        />
                        <Step3 number={3} insurances={calcData?.insurances || null} links={calcData?.links || null}/>
                        <Step4 number={4} services={calcData?.services || null}/>
                        <Step5 number={5} services={calcData?.services || null}/>
                        <Step6 number={6} services={calcData?.services || null}/>
                        <Step7 number={7}/>
                    </>)
                }
            </div>
            <aside className={styles.newOrder__aside}>
                <Summary
                    rates={calcData?.rates || []}
                    car={calcData?.car || null}
                    insurances={calcData?.insurances || null}
                    services={calcData?.services || null}
                    promoFinishDate={calcData?.price_data?.promo?.finish_date || null}
                    promoPriceGrid={calcData?.price_data?.promo?.grid || null}
                    priceGrid={calcData?.price_data?.grid || null}
                    links={calcData?.links || null}
                    version={ver}
                    crmCarId={calcData?.car?.carid || null}
                />
            </aside>
        </div>
    );
}

export default App;
